import dayjs from 'dayjs';
export class UserSeasonAggregate {
    constructor(data, config) {
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "playDuration", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "seasonStartAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "seasonEndAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userSeasonAggregateRank", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.userId = data.userId;
        this.playDuration = data.playDuration;
        this.seasonStartAt = data.seasonStartAt;
        this.seasonEndAt = data.seasonEndAt;
        this.userSeasonAggregateRank = new UserSeasonAggregateRank(data.userSeasonAggregateRank, config);
    }
    get playDurationMinute() {
        return Math.floor(this.playDuration / 60);
    }
    get seasonStartAtDayjs() {
        return dayjs.unix(this.seasonStartAt);
    }
    get seasonEndAtDayjs() {
        return dayjs.unix(this.seasonEndAt);
    }
}
export const UserSeasonAggregateRankName = {
    bronze: 'BRONZE',
    silver: 'SILVER',
    gold: 'GOLD',
    ruby: 'RUBY',
    sapphire: 'SAPPHIRE',
    diamond: 'DIAMOND',
};
export class UserSeasonAggregateRank {
    constructor(data, config) {
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nameJp", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "playDurationThreshold", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "thumbnailSrc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nextUserSeasonAggregateRank", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = data.name;
        this.nameJp = data.nameJp;
        this.playDurationThreshold = data.playDurationThreshold;
        this.thumbnailSrc = config.cdnBaseURL + data.thumbnailSrc;
        if (data.nextUserSeasonAggregateRank) {
            this.nextUserSeasonAggregateRank = new UserSeasonAggregateRank(data.nextUserSeasonAggregateRank, config);
        }
    }
    get isBronze() {
        return this.name === UserSeasonAggregateRankName.bronze;
    }
    get isSapphire() {
        return this.name === UserSeasonAggregateRankName.sapphire;
    }
    get isDiamond() {
        return this.name === UserSeasonAggregateRankName.diamond;
    }
    get playDurationThresholdMinute() {
        return Math.floor(this.playDurationThreshold / 60);
    }
}
